import React from 'react'
import { SignForm } from '@shared/components/forms/sign'
import { Section } from '@shared/components/section'

export const View = () => (
	<Section fullWidth>
		<SignForm />
	</Section>
)
